import EtpManage from './index';
import EtpMarge from './EtpMarge';
import Billboard from './Billboard';
import DataOverview from './DataOverview';
import ManageFee from './ManageFee';
import TradeData from './TradeData';
import PositionData from './PositionData';
import ProfitLossData from './ProfitLossData';
import ServiceFee from './ServiceFee';

export default {
    path: 'etp/system',
    component: EtpManage,
    children: [
        {path: '/etp/system/etpMerge', component: EtpMarge},
        {path: '/etp/system/billboard', component: Billboard},
        {path: '/etp/system/dataOverview', component: DataOverview},
        {path: '/etp/system/manageFee', component: ManageFee},
        {path: '/etp/system/tradeData', component: TradeData},
        {path: '/etp/system/positionData', component: PositionData},
        {path: '/etp/system/profitLossData', component: ProfitLossData},
        {path: '/etp/system/serviceFee', component: ServiceFee}
    ]
}
